import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ChevronLeft } from "lucide-react";
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Dialog,
  DialogContent,
  FormControl,
} from "@mui/material";
import { api } from "../../api/api";
import { Order_summary } from "../../api/urls";
import { toast } from "react-toastify";

const Payment = ({ address, onClose }) => {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const cart = useSelector((state) => state.cart);

  const handleSubmit = async () => {
    if (!paymentMethod) {
      toast.error("Please select a payment method");
      return;
    }

    if (!cart.length) {
      toast.error("Your cart is empty");
      return;
    }

    setIsSubmitting(true);
    try {
      // const item = cart[0];
      const item = { ...cart[0] };
      const orderData = {
        product: item.product,
        hexcolor: item.hexcolor,
        size_label: item.size_label || null,
        quantity: item.quantity || 1,
        payment_method: paymentMethod === "cod" ? "Cash On Delivery" : "Online",
        shipping_id: address.id,
        billing_id: address.id,
      };

      const response = await api.post(Order_summary, orderData);

      // window.open(response?.data?.pay);
      window.location.href = response?.data?.pay;

      navigate("/your_order");
    } catch (error) {
      console.error("Payment error:", error);
      toast.error(
        `Payment failed: ${error.response?.data?.message || error.message}`
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open fullWidth maxWidth="xs" onClose={onClose}>
      <DialogContent>
        <Box
          sx={{
            p: 3,
            display: "flex",
            flexDirection: "column",
            textAlign: "start",
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            mb={3}
            sx={{ cursor: "pointer", alignSelf: "flex-start" }}
            onClick={onClose}
          >
            <ChevronLeft />
            <Typography variant="body1">Back</Typography>
          </Box>

          <Typography
            sx={{ fontFamily: "'Inter', sans-serif" }}
            variant="h6"
            gutterBottom
          >
            Select Payment Method
          </Typography>

          <FormControl component="fieldset" sx={{ width: "100%", mb: 3 }}>
            <RadioGroup
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <FormControlLabel
                value="cod"
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": {
                        color: "black",
                      },
                    }}
                  />
                }
                label="Cash on Delivery"
                sx={{ justifyContent: "start", mr: 0 }}
              />
              <FormControlLabel
                value="online"
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": {
                        color: "black",
                      },
                    }}
                  />
                }
                label="Online Payment"
                sx={{ justifyContent: "start", mr: 0 }}
              />
            </RadioGroup>
          </FormControl>

          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            disabled={!paymentMethod || isSubmitting}
            sx={{
              backgroundColor: "black",
              "&:hover": {
                backgroundColor: "#333",
              },
            }}
          >
            {isSubmitting ? "Processing..." : "Complete Order"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default Payment;
